// Função para validar CPF
export const validarCPF = (cpf: string): boolean => {
    cpf = cpf.replace(/\D/g, ""); // Remove caracteres não numéricos
    if (cpf.length !== 11 || /^(\d)\1{10}$/.test(cpf)) return false; // Verifica tamanho e sequência repetida
  
    let soma = 0, resto;
  
    // Cálculo do primeiro dígito verificador
    for (let i = 0; i < 9; i++) soma += parseInt(cpf.charAt(i)) * (10 - i);
    resto = (soma * 10) % 11;
    if (resto === 10 || resto === 11) resto = 0;
    if (resto !== parseInt(cpf.charAt(9))) return false;
  
    // Cálculo do segundo dígito verificador
    soma = 0;
    for (let i = 0; i < 10; i++) soma += parseInt(cpf.charAt(i)) * (11 - i);
    resto = (soma * 10) % 11;
    if (resto === 10 || resto === 11) resto = 0;
    if (resto !== parseInt(cpf.charAt(10))) return false;
  
    return true;
  };
  
  // Função para validar CNPJ
  export const validarCNPJ = (cnpj: string): boolean => {
    cnpj = cnpj.replace(/\D/g, ""); // Remove caracteres não numéricos
    if (cnpj.length !== 14 || /^(\d)\1{13}$/.test(cnpj)) return false; // Verifica tamanho e sequência repetida
  
    const calcularDigito = (cnpjParcial: string, pesos: number[]): number => {
      let soma = 0;
      for (let i = 0; i < pesos.length; i++) {
        soma += parseInt(cnpjParcial.charAt(i)) * pesos[i];
      }
      const resto = soma % 11;
      return resto < 2 ? 0 : 11 - resto;
    };
  
    // Pesos para cálculo dos dígitos verificadores
    const pesos1 = [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
    const pesos2 = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
  
    const primeiroDV = calcularDigito(cnpj.slice(0, 12), pesos1);
    const segundoDV = calcularDigito(cnpj.slice(0, 12) + primeiroDV, pesos2);
  
    return primeiroDV === parseInt(cnpj.charAt(12)) && segundoDV === parseInt(cnpj.charAt(13));
  };
  